<div class="signup-form flex flex-col w-full gap-3">
  <div class="flex items-center justify-center">
    <span class="text-primarys shadow-lg p-2">Signup Now</span>
  </div>
  <div class="flex items-center justify-center" *ngIf="orgName">
    <span class="text-primary">{{ orgName }}</span>
  </div>

  <mat-horizontal-stepper [linear]="true" #stepper class="signup-stepper">
    <mat-step [stepControl]="userAForm">
      <form [formGroup]="userAForm" class="w-full">
        <ng-template matStepLabel>Company</ng-template>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-4">
          <div class="signup-field">
            <span class="signup-label">Company Name</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <input matInput formControlName="org_name" />
              <mat-error *ngIf="userAForm.get('org_name')?.hasError('required')">
                Organization name is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">Org Type</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <mat-select formControlName="org_type" required>
                <mat-option value="cooperative">Cooperative (Co-op)</mat-option>
                <mat-option value="corporation">Corporation</mat-option>
                <mat-option value="franchise">Franchise</mat-option>
                <mat-option value="government_organization">Government Organization</mat-option>
                <mat-option value="joint_venture">Joint Venture</mat-option>
                <mat-option value="opc">One Person Company (OPC)</mat-option>
                <mat-option value="partnership">Partnership</mat-option>
                <mat-option value="private_limited">Private Limited Company (Pvt Ltd)</mat-option>
                <mat-option value="psu">Public Sector Undertaking (PSU)</mat-option>
                <mat-option value="public_limited">Public Limited Company (Ltd)</mat-option>
                <mat-option value="sole_proprietorship">Sole Proprietorship</mat-option>
                <mat-option value="trust">Trust</mat-option>
              </mat-select>
              <mat-error *ngIf="userAForm.get('org_type')?.hasError('required')">
                Org type is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">Domain</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <mat-select formControlName="domain" [multiple]="true" required>
                <mat-option value="Consultancy">Consultancy</mat-option>
                <mat-option value="Construction">Construction</mat-option>
                <mat-option value="Road">Road</mat-option>
                <mat-option value="Utilities">Utilities</mat-option>
              </mat-select>
              <mat-error *ngIf="userAForm.get('domain')?.hasError('required')">
                Domain is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">CIN Number</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <input matInput formControlName="registration_number" />
              <mat-error *ngIf="userAForm.get('registration_number')?.hasError('required')">
                Registration Number is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">GST Number</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <input matInput formControlName="gst_number" />
              <mat-error *ngIf="userAForm.get('gst_number')?.hasError('required')">
                GST Number is required
              </mat-error>
              <mat-error *ngIf="userAForm.get('gst_number')?.hasError('pattern')">
                GST Number Pattern
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">PAN</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <input matInput formControlName="pan_number" />
              <mat-error *ngIf="userAForm.get('pan_number')?.hasError('required')">
                PAN is required
              </mat-error>
              <mat-error *ngIf="userAForm.get('pan_number')?.hasError('pattern')">
                PAN Pattern
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">Address Line 1</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <input matInput formControlName="address_line_1" />
              <mat-error *ngIf="userAForm.get('address_line_1')?.hasError('required')">
                Company street is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">Address Line 2</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <input matInput formControlName="address_line_2" />
              <mat-error *ngIf="userAForm.get('address_line_2')?.hasError('required')">
                Company address is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">Country</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <mat-select formControlName="country" (selectionChange)="onCountryChange()" required>
                <mat-option value="">Select Country</mat-option>
                <mat-option value="India">India</mat-option>
              </mat-select>
              <mat-error *ngIf="userAForm.get('country')?.hasError('required')">
                Country is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">State</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <mat-select formControlName="state" (selectionChange)="onStateChange()" required>
                <mat-option value="">Select State</mat-option>
                <mat-option *ngFor="let state of states" [value]="state">{{ state }}</mat-option>
              </mat-select>
              <mat-error *ngIf="userAForm.get('state')?.hasError('required')">
                State is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">City</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <mat-select formControlName="city" required>
                <mat-option value="">Select City</mat-option>
                <mat-option *ngFor="let city of cities" [value]="city">{{ city }}</mat-option>
              </mat-select>
              <mat-error *ngIf="userAForm.get('city')?.hasError('required')">
                City is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">Postal Code</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <input matInput formControlName="postal_code" />
              <mat-error *ngIf="userAForm.get('postal_code')?.hasError('required')">
                Postal code is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex items-center gap-6 flex-wrap" style="margin-bottom: 5px;">
          <div class="flex flex-col gap-2">
            <span class="signup-label">Upload Logo</span>
            <button type="button" mat-raised-button color="primary" (click)="fileInput.click()">
              Choose Logo
            </button>
            <input type="file" accept="image/*" hidden #fileInput (change)="onFileSelected($event)" />
          </div>

          <div *ngIf="imagePreview" class="rounded border border-gray-300 p-2">
            <img [src]="imagePreview" alt="Preview" class="max-w-[200px] max-h-[150px] object-contain" />
          </div>
        </div>

        <div class="form-actions text-center">
          <button type="button" mat-raised-button color="primary" matStepperNext [disabled]="!userAForm.valid"
            (click)="nameFach()">Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="userBForm">
      <form [formGroup]="userBForm" class="w-full">
        <ng-template matStepLabel>Primary Contact</ng-template>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-4">
          <div class="signup-field">
            <span class="signup-label">Name</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <input matInput formControlName="primary_contact_name" required>
              <mat-error *ngIf="userBForm.get('primary_contact_name')?.hasError('required')">
                Name is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">Email</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <input matInput formControlName="primary_contact_email" required>
              <mat-error *ngIf="userBForm.get('primary_contact_email')?.hasError('required')">
                Email is required
              </mat-error>
              <mat-error *ngIf="userBForm.get('primary_contact_email')?.hasError('email')">
                Invalid email
              </mat-error>
            </mat-form-field>
          </div>

          <div class="signup-field">
            <span class="signup-label">Mobile</span>
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <input matInput formControlName="primary_contact_phone" required>
              <mat-error *ngIf="userBForm.get('primary_contact_phone')?.hasError('required')">
                Mobile is required
              </mat-error>
              <mat-error *ngIf="userBForm.get('primary_contact_phone')?.hasError('pattern')">
                Must be a 10-digit number
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-actions">
          <button type="button" mat-button matStepperPrevious style="margin-right: 5px;">Back</button>
          <button type="button" mat-raised-button color="primary" matStepperNext [disabled]="!userBForm.valid"
            (click)="signUp()">Submit</button>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>

  <div class="login-section p-2">
    <button mat-stroked-button color="primary" class="login-btn" (click)="goToSignin()">
      <mat-icon>login</mat-icon>
      Go to Login
    </button>
  </div>
  <div *ngIf="false" class="login-buttons">
    <button (click)="loginWithGoogle()">
      <img src="../../../assets/image/envelope.png" alt="Google" />
      Signup with Google
    </button>

    <button (click)="loginWithFacebook()">
      <img src="../../../assets/image/facebook.png" alt="Facebook" />
      Signup with Facebook
    </button>
  </div>
</div>
